import React, { createContext } from "react";

const ControlContext = createContext();

export default ControlContext;

export const ControlProvider = ({ children }) => {
	const handleAddRecord = (
		setSalesRecord,
		gridValues,
		setgridValues,
		salesRecord,
		defaultSalesRecord
	) => {
		setgridValues((gridValues) => [...gridValues, salesRecord]);
		setSalesRecord(defaultSalesRecord);
	};

	const handleEditRecord = (
		itemCode,
		setSalesRecord,
		gridValues,
		setEditting
	) => {
		setSalesRecord(
			gridValues.find((record) => record.itemCode === itemCode),
			1
		);
		setEditting(true);
	};

	const handleSaveEdit = (
		itemCode,
		setSalesRecord,
		gridValues,
		salesRecord,
		defaultSalesRecord,
		setgridValues,
		setEditting
	) => {
		setSalesRecord(gridValues.find((record) => record.itemCode === itemCode));
		setgridValues(gridValues.filter((record) => record.itemCode !== itemCode));
		setgridValues((gridValues) => [...gridValues, salesRecord]);
		setSalesRecord(defaultSalesRecord);
		setEditting(false);
	};

	const handleDeleteRecord = (
		itemCode,
		gridValues,
		setgridValues,
		setSalesRecord,
		defaultSalesRecord
	) => {
		setgridValues(gridValues.filter((record) => record.itemCode !== itemCode));
		setSalesRecord(defaultSalesRecord);
	};

	let contextData = {
		handleEditRecord: handleEditRecord,
		handleSaveEdit: handleSaveEdit,
		handleDeleteRecord: handleDeleteRecord,
        handleAddRecord: handleAddRecord
	};

	return (
		<ControlContext.Provider value={contextData}>
			{children}
		</ControlContext.Provider>
	);
};
